<template>
  <div>
    <div style="margin: 4px">
      <v-card class="mb-12">
        <v-card-title>
          <span class="headline">Efeito Planejado</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-form ref="effectsForm" v-model="valid" lazy-validation>
                  <p class="body-1">
                    Impacto esperado * – quantidade de pessoas/famílias
                    beneficiadas, melhorias de indicadores, território
                    contemplado etc
                  </p>
                  <v-textarea
                    color="secondary"
                    outlined
                    auto-grow
                    row-height="18"
                    v-model="project.impact"
                    :rules="requiredRule"
                    required
                  ></v-textarea>
                  <!-- <div v-if="this.$store.state.isCnpj === false"> -->
                  <div>
                    <p class="body-1">
                    Qual é a vinculação com o plano de governo? *
                  </p>
                  <v-textarea
                    color="secondary"
                    outlined
                    auto-grow
                    row-height="18"
                    v-model="project.planLink"
                    :rules="requiredRule"
                    required
                  ></v-textarea>
                  </div>
                  <p class="body-1">Prazo de execução *</p>
                  <v-text-field
                    color="secondary"
                    outlined
                    v-model="project.executionTime"
                    :rules="requiredRule"
                    maxlength="255"
                    required
                  ></v-text-field>
                  <small>* Campo de preenchimento obrigatório</small>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <v-container class="pa-0">
      <v-row justify="space-between">
        <v-col class="col-button">
          <v-btn text color="default" @click="previous">
            Anterior
          </v-btn>
        </v-col>
        <v-col class="col-button">
          <v-btn class="ml-auto" color="secondary" @click="next">
            Próximo
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    requiredRule: [v => !!v || 'Campo obrigatório'],
    project: {},
  }),

  methods: {
    validate() {
      return this.$refs.effectsForm.validate();
    },
    reset() {
      this.$refs.effectsForm.reset();
    },
    resetValidation() {
      this.$refs.effectsForm.resetValidation();
    },
    next() {
      if (this.validate()) {
        this.$store.dispatch('editProject', this.project);
        this.$emit('next');
      }
    },
    previous() {
      this.$emit('previous');
    },
  },

  created() {
    this.project = this.$store.state.project;
  },
};
</script>

<style scoped>
form p {
  margin-bottom: 8px;
}
.col-button {
  flex-grow: unset;
  padding: 0 16px 16px;
}
</style>
